import { format, parseISO, differenceInYears, differenceInMonths } from 'date-fns';

/**
 * Format date to readable string
 */
export const formatDate = (date: Date | string, pattern: string = 'yyyy-MM-dd'): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, pattern);
};

/**
 * Format date and time
 */
export const formatDateTime = (date: Date | string): string => {
  return formatDate(date, 'yyyy-MM-dd HH:mm');
};

/**
 * Calculate age from birthdate
 */
export const calculateAge = (birthDate: Date | string): number => {
  const birthDateObj = typeof birthDate === 'string' ? parseISO(birthDate) : birthDate;
  return differenceInYears(new Date(), birthDateObj);
};

/**
 * Calculate age with years and months from birthdate
 * @returns Object with years and months
 */
export const calculateAgeWithMonths = (
  birthDate: Date | string
): { years: number; months: number } => {
  const birthDateObj = typeof birthDate === 'string' ? parseISO(birthDate) : birthDate;
  const today = new Date();
  const totalMonths = differenceInMonths(today, birthDateObj);
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  return { years, months };
};

/**
 * Check if date is in the past
 */
export const isPastDate = (date: Date | string): boolean => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return dateObj < new Date();
};
